import { Injectable } from '@angular/core';
import { ApiClient } from '../http/api-client';

@Injectable({
  providedIn: 'root'
})
export class VendorGroupsQuestionsService {

  constructor(
      private restangular: ApiClient
  ) { }

  getAllVendorGroupQuestions(limit = 10000, offset = 0, search = ''): Promise<any> {
    return this.restangular.one(`/vendors/groups/questions?limit=${limit}&offset=${offset}&search=${encodeURIComponent(search)}`).get().toPromise();
  }

  createVendorGroupQuestion(metadata: any): Promise<any> {
    return this.restangular.one('/vendors/groups/questions').customPOST({
      ...metadata,
    }).toPromise();
  }

  modifyVendorGroupQuestion(id: string, fields: any): Promise<any> {
    return this.restangular.one('/vendors/groups/questions', id).customPUT({
      ...fields
    }).toPromise();
  }

  deleteVendorGroupQuestion(id: string): Promise<any> {
    return this.restangular.one('vendors/groups/questions', id).remove().toPromise();
  }
}
